<template>
    <div v-if="isVisible" class="loader-overlay">
        <div class="loader">
        </div>    
    </div>
</template>

<script>
    export default {
        name: "Loaders",
        props: {
            isVisible: {type: Boolean, required: true},
        },
    }
</script>

<style lang="scss">
    .loader-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #33333340;
        z-index: 1;
        cursor: pointer;
        span.text {
            display: inline-block;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            color: #169754;
        }
        .loader {
            border: 5px solid #d3ecde; /* Light grey */
            border-top: 5px solid #3498db; /* Blue */
            border-radius: 50%;
            width: 40px;
            height: 40px;
            position: absolute;
            top: 35%;
            left: 0;
            right: 0;
            bottom: 0;
            animation: spin 2s linear infinite;
            -webkit-animation: spin 2s linear infinite; /* Safari */
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        /* Safari */
        @-webkit-keyframes spin {
            0% { -webkit-transform: rotate(0deg); }
            100% { -webkit-transform: rotate(360deg); }
        }
    }
</style>